import UpdateIcon from "@mui/icons-material/Update";
import YouTubeIcon from "@mui/icons-material/YouTube";
import ArticleIcon from "@mui/icons-material/Article";
import PaymentsIcon from "@mui/icons-material/Payments";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import GroupsIcon from "@mui/icons-material/Groups";

const sidebarMenuItemList = [
  {
    label: "",
    items: [
      {
        label: "Recent Projects",
        target: "_self",
        to: "/projects",
        icon: UpdateIcon,
      },
    ],
  },
  {
    label: "Account",
    items: [
      {
        label: "Credits & Billing",
        target: "_self",
        to: "/billing",
        icon: PaymentsIcon,
      },
      {
        label: "Purchase history",
        target: "_self",
        to: "/purchase-history",
        icon: ReceiptLongIcon,
      },
      {
        label: "Team",
        target: "_self",
        to: "/team",
        icon: GroupsIcon,
      },
    ],
  },
  {
    label: "Learning",
    items: [
      {
        label: "Video Tutorials",
        target: "_blank",
        to: "https://www.youtube.com/@SWIS_ZIGGURAT",
        icon: YouTubeIcon,
      },
      {
        label: "Blog Articles",
        target: "_blank",
        to: "https://swis-gmbh.de/blog/",
        icon: ArticleIcon,
      },
    ],
  },
];

export default sidebarMenuItemList;
